"use strict";

exports.__esModule = true;
/*eslint-env browser*/

exports.default = {
  pool: {
    size: navigator.hardwareConcurrency || 8
  }
};
//# sourceMappingURL=defaults.browser.js.map



//////////////////
// WEBPACK FOOTER
// ./~/threads/lib/defaults.browser.js
// module id = 34
// module chunks = 2